import { Pages } from "../../../utils";
import { StickyContentProps } from "./sticky-content";

export const stickyContent: StickyContentProps[] = [
  {
    title: "Exclusively Yours",
    subTitle: "THE EXCLUSIVITY ADVANTAGE",
    description:
       "Join Home Design Guild and experience the difference a designer-first, designer-only platform can make.",
    childContent: [
      {
        title: "Focused on Home Design ",
        description:
          "We exclusively generate demand and client leads for Interior Designer and Decorator Services. No other industries need apply.",
        buttonText: "Apply Today",
        to: Pages.SIGNUP,
      },
      {
        title: "Memberships Are Vetted",
        description:
          "Every member of our design community is thoroughly vetted through a meticulous screening process. We’re committed to building a community of experts as committed as you are.",
        buttonText: "Our Design Community",
        to: Pages.DESIGN_COMMUNITY,
      },
      {
        title: "Memberships Are Limited",
        description:
          "Limited interior designer and decorator memberships per territory ensure the highest Return on Investment for each member of our design community.",
        buttonText: "Our Territories",
        to: Pages.TERRITORIES,
      },
    ],
  },

  {
    title: "Every Client, Exceptional",
    subTitle: "THE HOMEOWNER ADVANTAGE",
    description:
      "Home Design Guild eliminates the guesswork of fielding prospective projects to ensure you’re building on a foundation of chemistry, compatibility and mutual expectations. ",
    childContent: [
      {
        title: "Hitting The Bullseye",
        description:
          "Our marketing efforts target homeowners currently searching to hire an Interior Designer or Decorator as well as those who need a little nudge. Our targets come from a variety of demographic and psychological backgrounds, but share certain characteristics.",
        buttonText: "Our Homeowners",
        to: Pages.HOMEOWNER_LANDING,
      },
      {
        title: "Real Leads, Really Educated",
        description:
          "Once a homeowner has joined Home Design Guild we send them on an exciting journey of discovery, discernment and definition in three distinct educational onboarding stages.",
        buttonText: "Our Education",
        to: Pages.COMING_SOON,
      },
      {
        title: "Matching Built With Brains",
        description:
          "Our Smart-Guild Matching technology takes relationships seriously - because great relationships deliver maximum return. We are the only platform that matches based on 40+ variables that cover personality, preference and the project. ",
        buttonText: "Our Matching Difference",
        to: Pages.COMING_SOON,
      },
    ],
  },

  {
    title: "Your Marketing Co-Pilot",
    subTitle: "THE MARKETING ADVANTAGE",
    description:
      "We are so confident in our ability to drive qualified leads into the pipeline, that for a limited time under our Beta Memberships you don’t pay any membership fee until you receive your first lead.",
    childContent: [
      {
        title: "Amplify Your Voice",
        description:
          "Maximize your visibility and reach the right audience with included advertising. A portion of every designer’s membership fees are allocated to their territory’s marketing budget.",
        buttonText: "Our Marketing",
        to: Pages.COMING_SOON,
      },
      {
        title: "Maximize Your Marketing Investments ",
        description:
          "Within our membership tiers members have access to automated email campaigns that help ensure you stay top of mind with your client after the project is completed for referrals and reviews.  ( Coming Soon )",
        buttonText: "View more",
        to: Pages.COMING_SOON,
      },
      {
        title: "Decisions Backed by The Seal ",
        description:
          "For homeowners, the lack of industry standards makes it difficult to understand who to trust or hire. We will market to homeowners, educating them to look for the HDG Seal of Approval when hiring a designer. Whether they go through our matching portal or not, the seal will help you distinguish yourself in the market as a vetted, quality professional.",
        buttonText: "View more",
        to: Pages.COMING_SOON,
      },
      {
        title: "Premium Designer Bio",
        description:
          "When matched, homeowners are connected directly to your designer bio and portfolio. They then make the first move to initiate contact directly within your hub, eliminating the wasted time of chasing down leads through emails, phone calls and text messages.",
        buttonText: "View more",
        to: Pages.COMING_SOON,
      },
    ],
  },

  {
    title: "The Platform That Pays You.",
    subTitle: "THE RETURN ON INVESTMENT ADVANTAGE",
    description:
      "Every designer we talk to is looking for additional ways to fuel their revenue stream. With Home Design Guild we provide you with opportunities to earn more utilizing work you already do.",
    childContent: [
      {
        title: "Earn Cash",
        description:
          "Design Membership Members share 10% of the profit from our Homeowner Memberships. Must meet minimum requirements to be eligible.",
        buttonText: "Designer Files",
        to: Pages.COMING_SOON,
      },
      {
        title: "Earn Commissons",
        description:
          "Earn Commissions & Increase Project Budgets with Home Design Guild’s Financing Program.",
        buttonText: "Our Financing",
        to: Pages.FINANCING,
      },
      {
        title: "Earn Credits",
        description:
          "Members have the opportunity to refer designer colleagues to HDG for an opportunity to earn membership credits.",
        buttonText: "Designer Referral Progam",
        to: Pages.COMING_SOON,
      },
    ],
  },

  //   {
  //     title: "Time-Saving Collaboration Tools",
  //     subTitle: "THE ONE PLATFORM ADVANTAGE",
  //     description:
  //       "Within the Designer Hub you can chat with your design peers, contribute to “the list” a rating and review system for those that service our industry. As well as enjoy access to sweet deals just for HDG members.",
  //     childContent: [
  //       {
  //         title: "Chatter",
  //         description:
  //           "Ask for advice, ideas or just vent! With your membership you get access to chat with our members and search previous topics shared within our Chatter forum.",
  //         buttonText: "View more",
  //         to: `${Pages.ABOUT_DESIGN_HUB}#chatter`,
  //       },
  //       {
  //         title: "The List",
  //         description:
  //           "The List is a community generated, peer reviewed directory of vendors and service providers within our industry. With The List you can submit, search, review and share your vendor experiences.",
  //         buttonText: "View more",
  //         to: `${Pages.ABOUT_DESIGN_HUB}#thelist`,
  //       },
  //       {
  //         title: "Affiliate Offers",
  //         description:
  //           "Our members enjoy special pricing and offers with 3rd party organizations that support the design industry.",
  //         buttonText: "View Affiliate Types",
  //         to: `${Pages.ABOUT_DESIGN_HUB}#affiliates`,
  //       },
  //     ],
  //   },
];
